import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import { validateRefId } from '../../utils/helperFn';
import instance from '../../utils/axios';
import { changeLang } from '../../redux/actions/appSettings.actions';
import i18next from 'i18next';
import { getApiUrl } from '../../utils/apiUrls';
import ProgressBar from '../progress-bar/ProgressBar.component';
import { LOGIN } from '../../redux/actions/actions.types';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { logout } from '../../redux/actions/user.actions';

const ProtectedRoute = ({children}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const [searchParams, setSearchParams] = useSearchParams();
    const rawRefId = searchParams.get('refId');
    const refId = validateRefId(rawRefId);
    const returnUrl = searchParams.get('returnUrl');
    const sessionId = searchParams.get('sessionId');
    const lang = searchParams.get('lang');
    const savedReturnUrl = useSelector(state => state.user?.returnUrl);
    const [showProtectedPage, setShowProtectedPage] = React.useState({
        show: false,
        isLoading: true,
    });

    const getToken = async (sessionId) => {
        try {
            const res = await axios.get(`${getApiUrl("loginDashboard")}?sessionId=${sessionId}`);

            if(res.data?.jwtToken) {
                saveUser(res.data.jwtToken, lang);
            }
        } catch (error) {
            if(error.response.status === 401) dispatch(logout())
        }
    }

    React.useEffect(() => {
        if(sessionId) {
            if(sessionId) {
                getToken(sessionId);
            } else {
                setShowProtectedPage({
                    show: false,
                    isLoading: false,
                });
            }
        } else {
            setShowProtectedPage({
                show: !!user,
                isLoading: false,
            });
        }
    }, [user])


    const saveUser = async (jwtToken, lang) => {
        setShowProtectedPage({
            show: true,
            isLoading: false,
        });
        const decodedData = jwtDecode(jwtToken);

        localStorage.setItem("token", jwtToken);

        if (!!lang) {
            const res = await instance.post(`${getApiUrl("saveLanguage")}/${lang}`);

            if (res.data.statusCode === "SUCCESS") {
                dispatch(changeLang(lang));
                i18next.changeLanguage(lang);
            }
        } else {
            const res = await instance.get(`${getApiUrl("getLastLanguageUsed")}`);

            dispatch(changeLang(!!res.data ? res.data : "en"));
            i18next.changeLanguage(!!res.data ? res.data : "en");
        }

        dispatch({
            type: LOGIN,
            payload: {...JSON.parse(decodedData.sub), returnUrl: returnUrl ? returnUrl : null},
        });

        if(sessionId) {
            searchParams.delete("sessionId");
        }
        if(returnUrl) {
            searchParams.delete("returnUrl");
        }
        setSearchParams(searchParams);

        return;
    };

    const navigateToReturnUrl = () => {
        window.location.href = savedReturnUrl;
    }

    return(
        !showProtectedPage?.isLoading ? showProtectedPage.show ? children : savedReturnUrl ? navigateToReturnUrl : <Navigate to={`/login${refId ? `?refId=${refId}` : ''}`} replace={true} /> : <div className='d-flex align-items-center justify-content-center'>
            <ProgressBar />
        </div>
    )

}

export default ProtectedRoute;